import { render } from "./SettingsBar.vue?vue&type=template&id=591c08f2&scoped=true"
import script from "./SettingsBar.vue?vue&type=script&lang=js"
export * from "./SettingsBar.vue?vue&type=script&lang=js"

import "./SettingsBar.vue?vue&type=style&index=0&id=591c08f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-591c08f2"]])

export default __exports__